import { environment } from '../environments/environment';

export const noAuthDomains = [
  'https://app-meta.fxhedgepool.com/',
  `${environment.zuul}user/login`,
  `${environment.zuul}user/login/verify`,
  `${environment.zuul}user/login/refresh-token`,
  `${window.location.origin}/feature-flags`,
];
